import React, { useState } from "react";
import { Button, Modal } from "antd";
import { useSelector } from "react-redux";

import FreemiumVesselCard from "./FreemiumVesselCard";
import FreemiumPage from "./FreemiumPage";
import FreemiumEventsCard from "./FreemiumEventsCard";
import FreemiumTabComponent from "../../components/FreemiumTab";
import EmissionsReport from "../../pages/freemium/EmissionsReport";

import "../../css/freemium.css";

const Freemium = () => {
  const [vesselData, setVesselData] = useState({});
  const [fuelRows, setFuelRows] = useState([]);
  const [biofuelMeta, setBiofuelMeta] = useState([]);
  const [selectedYear, setSelectedYear] = useState("2026");
  const [isIceClass, setIsIceClass] = useState(false);
  
  // NEW: Ice class data state
  const [iceClassData, setIceClassData] = useState({
    iceClassType: undefined,
    iceDistance: undefined,
  });

  const [showPreviousReports, setShowPreviousReports] = useState(false);
  const [showResultModal, setShowResultModal] = useState(false);

  const { freemiumReportData } = useSelector((state) => state.voyage);
  const latestReport = freemiumReportData?.[0];

  return (
    <main className="main-board">
      <div className="freemium-title-container">
        <h2 className="freemium-title">EU Tax Estimator</h2>
        <Button onClick={() => setShowPreviousReports(true)}>
          Previous Reports
        </Button>
      </div>

      <div className="freemium-layout-scroll">
        <div className="freemium-layout">
          <FreemiumVesselCard onChange={setVesselData} />

          <FreemiumPage
            vesselData={vesselData}
            fuelRows={fuelRows}
            biofuelMeta={biofuelMeta}
            selectedYear={selectedYear}
            isIceClass={isIceClass}
            iceClassData={iceClassData} 
            openFuelModal={() => setShowResultModal(true)}
          />

          <FreemiumEventsCard
            onFuelChange={setFuelRows}
            onBiofuelChange={setBiofuelMeta}
            onYearChange={setSelectedYear}
            onIceClassChange={setIsIceClass}
            onIceClassDataChange={setIceClassData} 
          />
        </div>
      </div>

      <div className="last-section">
        <Button
          className="end_button"
          onClick={() =>
            document.dispatchEvent(new Event("CALCULATE_FREEMIUM"))
          }
        >
          <h3>Generate Compliance Report</h3>
        </Button>
      </div>

      <FreemiumTabComponent
        showModal={showPreviousReports}
        setShowModal={setShowPreviousReports}
      />

      <Modal
        open={showResultModal}
        onCancel={() => setShowResultModal(false)}
        footer={null}
        width={1200}
        centered
        destroyOnClose
        closeIcon={<span style={{ fontSize: '15px', color: 'red', background: "white"  }}>✕</span>}  
      >
        <EmissionsReport data={latestReport} />
      </Modal>
    </main>
  );
};

export default Freemium;
